import Svg, { Path } from 'react-native-svg'

const MyDeviceIcon = ({ width = 24, height = 24, color = '#000' }: any) => (
  <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
    <Path
      fill={color}
      d="M21.12 4.88A3 3 0 0 0 19 4H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V7a3 3 0 0 0-.88-2.12ZM12 18a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm5-8H7a1 1 0 0 1 0-2h10a1 1 0 1 1 0 2Z"
    />
  </Svg>
)
export default MyDeviceIcon
